export default {
  button: {
    synchronization: '数据同步',
    validation: '数据校验',
    enable: '启用',
    disable: '禁用',
    retrying: '重试',
    cancelRetrying: '取消重试',
    ok: '确定',
    empty: '清空',
    counting: '盘点',
    callCarCounting: '盘点叫车',
    callCarOutbound: '下架叫车',
    callCarinbound: '上架叫车',
    inboundInventory: '库存上架',
    outboundInventory: '库存下架',
    go: 'GO',
    destruction: '销单',
    seed: '分播',
    call: '叫车',
    upself: '入库',
    outbound: '出库',
    confirm: '确认',
    cancel: '取消',
    query: '查询',
    reset: '重置',
    sendRCS: '发送RCS',
    fold: '收起',
    unfold: '展开',
    detail: '详情',
    edit: '编辑',
    editStorageRoom: '编辑库房',
    editZone: '编辑区域',
    editLocation: '编辑货位',
    add: '新增',
    addRole: '新增角色',
    addStorageRoom: '新增库房',
    addZone: '新增区域',
    addLocation: '新增货位',
    addMenu: '新增菜单',
    addChildrenMenu: '新增子菜单',
    addMethod: '新增方法',
    return: '返回',
    createOrder: '生成订单',
    refresh: '刷新',
    expConfirm: '导出',
    exportTemplate: '导出模板',
    impConfirm: '导入',
    operate: '操作',
    reloadColumn: '刷新列配置',
    reload: '刷新',
    insertActived: '新增',
    markCancel: '标记/取消',
    save: '保存',
    export: '导出',
    addCapacity: '新增容量',
    addProduct: '新增成品',
    addBom: '新增物料清单',
    addMaterial: '新增物料',
    delProduct: '删除成品',
    delBom: '删除物料清单',
    delMateriel: '删除物料',
    preview: '预览',
    print: '打印',
    printTag: '打印标签',
    printCRO: '打印验收单',
    printPWO: '打印上架单',
    printLoadingOrder: '打印装车单',
    cleanupStagingArea: '清空暂存区',
    queryDetail: '查看明细',
    addContainer: '新增容器',
    batchAddContainer: '批量新增容器',
    printOrder: '打印单据',
    printConfirm: '打印确认',
    delivery: '交接',
    queryInversed: '查看冲红',
    obtain: '索取',
    review: '复核',
    assign: '指派',
    approval: '审核',
    grant: '授权',
    lock: '锁定',
    unlock: '解锁',
    modify: '修改',
    cancelReceiving: '取消收货',
    submit: '提交',
    submitAndPrint: '提交并打印',
    addNeworder: '新增单据',
    reject: '驳回',
    shelfConfirm: '上架确认',
    clear: '清理',
    taken: '提取',
    takenSaleOrder: '提取出库单',
    addDetail: '新增明细',
    addCollect: '新增汇总',
    delete: '删除',
    resetPassword: '重置密码',
    changePassword: '修改密码',
    getFingerPrint: '指纹采集',
    cancelPutAway: '取消上架',
    moveOrder: '移库',
    inboundScan: '入库扫描',
    goBack: '回库',
    inboundComplete: '入库完成',
    outboundTaken: '出库索取',
    outboundComplete: '出库完成',
    commandActive: '指令激活',
    increasePriority: '提升优先级',
    bindSeedingPosition: '绑定播种位',
    scanUniqueCode: '唯一码入库扫描',
    outboundCode: '唯一码回库',
    appointLocation: '转指定货位',
    oneStepOutbound: '转一键出库',
    lockingStock: '锁定库存',
    unLockingStock: '解锁库存',
    checkConvertQualified: '待验转合格',
    checkConvertUnqualified: '待验转不合格',
    release: '放行',
    unRelease: '不放行',
    queryByRequirement: '筛选',
    receiptComplete: '收货完成',
    tagging: '赋码',
    oddTagging: '零头赋码',
    beginReconciliation: '开始对账',
    batchAdd: '批量新增',
    invert: '冲红',
    arrange: '安排波次',
    waveStatus: '波次状态',
    errorMessage: '错误信息',
    formatJson: '格式化JSON',
    uploadTemplate: '上传模板',
    savePrintConfig: '保存打印配置',
    savePrintTemplate: '保存打印模板',
    editPrintTemplate: '编辑打印模板',
    scanSupervisorCode: '扫描监管码',
    dataMaintenance: '资料维护',
    printRejectLabel: '打印拒收标签',
    printShelfLabel: '打印上架标签',
    reviewPass: '复核通过',
    reviewReject: '复核驳回',
    close: '关闭',
    rollback: '验收回滚',
    login: '确定',
    reviewConfirmed: '复核确认',
    drawDraft: '提取草稿',
    drawInventory: '提取库存',
    search: '搜索',
    complete: '完成',
    addOrderToWave: '波次加单',
    waveIssue: '波次下发',
    waveReplenish: '波次补货',
    removeOrder: '剔单',
    orderInvert: '整单冲红',
    stage: '集货',
    sealing: '封箱',
    split: '拆分',
    shortPicking: '短拣',
    rePrint: '重打标签',
    printAfterConfirm: '确认后拼箱补打',
    printGroupageDetail: '打印装箱明细',
    previewShipmentPrint: '预览随货同行单',
    printShipmentOrder: '打印随货同行单',
    printShipmentDifference: '打印差异单',
    approve: '审核',
    destroyEntry: '销毁录入',
    destroy: '销毁',
    maintain: '养护',
    maintenancePlanGeneration: '养护计划生成',
    printReplenishmentLabel: '打印补货标签',
    exchangeBox: '换箱',
    supervisionCodeCollection: '监管码采集',
    scanBarcode: '扫描条码',
    associativeEmptyBox: '关联空箱',
    bindExchangeBoxBarcode: '绑定换箱站条码',
    reissue: '补发',
    changeToDispatch: '转出库调度',
    invertAll: '一键冲红',
    obtainAll: '一键索取',
    issue: '下发',
    executeApprove: '存盘审核',
    log: '记录',
    allocatePackingPosition: '分配打包位',
    updateSeedingQuantity: '修改供包数量',
    sending: '发送',
    waveSending: '波次发送',
    detailSending: '明细重发',
    copy: '复制',
    editAutoTaskUser: '编辑自动作业人员',
    addLoadingOrder: '新增装车单',
    addLoadingDetail: '新增装车单明细',
    deleteLoadingOrder: '删除装车单',
    deleteLoadingDetail: '删除装车单明细',
    transferShipment: '转托运',
    oneClickEntry: '一键录入',
    coldChainEdit: '冷链编辑',
    deleteDetail: '明细删除',
    cancelOrder: '单据取消',
    lightUp: '亮灯',
    lightOff: '灭灯',
    seedingConfirm: '播种确认',
    checkIn: '登记',
    more: '更多'
  },
  placeholder: {
    pleaseInput: '请输入',
    editStorageRoom: '编辑库房',
    editZone: '编辑区域',
    editLocation: '编辑货位',
    operate: '操作',
    reloadColumn: '刷新列配置',
    reload: '刷新',
    insertActived: '新增',
    markCancel: '标记/取消',
    save: '保存',
    export: '导出.csv',
    add: '新增',
    addStorageRoom: '新增库房',
    addZone: '新增区域',
    addLocation: '新增货位',
    return: '返回',
    createOrder: '生成订单',
    refresh: '刷新',
    expConfirm: '导出',
    returnOrderNo: '退货单号',
    receiptOrderNo: '收货单号',
    ownerName: '货主名称',
    itemNo: '商品编号',
    itemName: '商品名称',
    lotNo: '批号',
    showSearch: '双击或回车选择',
    showTag: '请输入导入标识码(避免重复导入)',
    application: '应用类型',
    pleaseSelect: '请选择',
    scanSupervisionCode: '扫描监管码',
    account: '账户',
    password: '密码',
    pleaseEnterItemNo: '请输入商品编号',
    pleaseEnterItemName: '请输入商品名称',
    pleaseEnterOrderNo: '请输入出库单号',
    pleaseEnterCustomerNo: '请输入客户编号',
    pleaseEnterCustomerName: '请输入客户名称',
    storageRoom: '库房',
    zone: '区域',
    location: '货位',
    inventoryClerk: '盘点员',
    pleaseDoubleClickSelectItem: '请双击选择商品',
    pleaseDoubleClickSelectStorageRoom: '请双击选择库房',
    pleaseDoubleClickSelectLocation: '请双击选择货位',
    pleaseDoubleClickSelectContainer: '请双击选择容器',
    actualInventoryQuantity: '实盘数量',
    pleaseEnterInventoryReason: '请输入盘点原因...',
    no: '编号',
    operator: '操作人',
    pleaseSelectOwner: '请选择货主',
    pleaseSelectTransferType: '请选择移库类型',
    orderNo: '单据编号',
    transferBarcode: '移库条码',
    itemBarcode: '商品条码',
    pleaseEnterReason: '请输入原因...',
    pleaseEnterItemNoOrItemName: '请输入商品编号或商品名称',
    pleaseEnterContainerNo: '请输入容器信息进行检索',
    pleaseEnterLocationNo: '请输入货位信息',
    pleaseEnterLotNo: '请输入批号信息',
    pleaseEnterModel: '请输入版本信息',
    pleaseEnterBarcode: '请输入条码信息',
    pleaseEnterSerialNumber: '请输入唯一码信息',
    orderNoSearchTip: '请输入单据编号',
    reviewDeskSelectTip: '请选择复核台',
    owner: '货主',
    startTime: '开始时间',
    endTime: '结束时间',
    maintenanceMeasure: '养护措施',
    maintenanceAdvice: '养护意见',
    inventoryStatus: '库存状态',
    pleaseSelectTargetStorageRoom: '请选择目的库房',
    saleOrderNo: '销售单号',
    purchaseOrderNo: '采购单号',
    countingOrderNo: '盘点单号',
    ASNOrderNo: 'ASN单号',
    outboundOrderNo: '出库单号',

    supplierName: '供应商名称',
    mnemonicCode: '助记码',
    countingType: '盘点类型',
    customerName: '客户名称',
    commandStatus: '指令状态',
    commandId: '指令ID',
    replenishmentBarcode: '补货条码',
    wave: '波次',
    pickingOrderNo: '拣货单号',
    containerNo: '容器编号',
    loadingOrderNo: '装车单号',
    shipmentBarcode: '出库条码',
    packType: '包装类型',
    legalAttribute: '法定属性',
    brand: '品牌',
    season: '季节',
    storageRequest: '存储要求',
    dosageForm: '剂型',
    storageLocation: '存储位',
    exchangePosition: '换箱位',
    seedingPosition: '分播位',
    packingPosition: '打包位',
    stagingPosition: '集货位',
    visualized: '是否视觉',
    stagingCompleted: '是否集货',
    reviewed: '是否复核',
    operationType: '操作类型',
    startTimeToEndTime: '开始时间 —— 结束时间',
    pleaseSelectCountingType: '请选择盘点类型',
    customerNoTag: '补货无客户筛选',
    waveTag: '补货无波次筛选',
    itemFilter: '商品编号/助记码'
  },
  business: {
    label: {
      importStatus: '导入状态',
      abnormalCause: '异常原因',
      section: '货架号',
      side: 'A/B面',
      toLoc: '站点号',
      msg: '消息',
      transType: '传输类型',
      commandType: '指令类型',
      businessOrderNo: '业务单据编号',
      orderNo: '单据编号',
      orderNoB: '*单据编号',
      purchaseOrderNo: '采购单号',
      purchaseOrderOperator: '计划制单人',
      purchaseOrderSource: '计划来源',
      receiver: '收货员',
      importer: '接货人',
      owner: '货主',
      orderType: '订单类型',
      orderTypeNo: '订单类型编号',
      orderTypeName: '订单类型名称',
      itemType: '商品类型',
      itemTypeA: '*商品类型',
      itemTypeNo: '商品类型编号',
      itemTypeName: '商品类型名称',
      itemCategory: '商品类别',
      orderStatus: '订单状态',
      invoiceDate: '开票日期',
      customer: '客户',
      indexNo: '序号',
      buyer: '采购员',
      customerNo: '客户编号',
      customerName: '客户名称',
      notes: '备注',
      customerId: '单位ID',
      ownerId: '货主ID',
      itemNo: '商品编号',
      itemID: '商品ID',
      ChineseName: '中文名称',
      ChineseNameA: '中文名称',
      itemName: '商品名称',
      specification: '包装规格',
      daysOfValid: '效期天数',
      daysOfExpirationNearly: '近效期天数',
      daysOfProductionNearly: '近产期天数',
      daysOfInspectionNearly: '复检天数',
      daysOfMaintenanceNearly: '养护期天数',
      batch: '批次',
      batchId: '批次ID',
      batchNo: '批次编号',
      lotNo: '批号',
      location: '货位',
      putawayLocation: '分配货位',

      ownerNo: '货主编号',
      ownerName: '货主名称',
      enterpriseNo: '企业编号',
      enterpriseName: '企业名称',
      queryMode: '查询方式',
      storageRoom: '库房',
      inventoryStatus: '库存状态',
      qualityStatus: '质量情况',
      manufacturer: '生产厂家',
      manufacturerA: '生产厂家',
      producingArea: '商品产地',
      producingAreaA: '产地',
      license: '营业执照',
      permission: '许可证',
      practice: '规范',
      quality: '质量标准',
      whetherOddNumber: '零头',
      coldChains: '冷链',
      lockedCases: '锁定件数',
      lockedNumberOfEach: '锁定零散数',
      locker: '锁定人',
      lockedTime: '锁定时间',
      inboundTag: '入库标签',
      inboundAssessOrder: '入库验收单',
      inboundPutAwayOrder: '入库上架单',
      inventoryState: '库存状态',
      transitional: '在途',
      remainder: '零头',
      prioritized: '优先',
      pickingFirst: '拣选优先',
      inboundQuantity: '入库量',
      outboundQuantity: '出库量',
      replenishedFromQuantity: '补出量',
      replenishedToQuantity: '补入量',
      transferredFromQuantity: '移出量',
      transferredToQuantity: '移入量',
      availableOutboundQuantity: '可出库量',
      availableQuantity: '可用量',
      lockedQuantity: '锁定量',
      availableLockedQuantity: '可锁定数量',
      lockReasons: '锁定原因',
      containerNo: '容器编号',
      productionDate: '生产日期',
      validUntil: '有效期至',
      uom: '计量单位',
      factor: '件装量',
      innerFactor: '内包量',
      quantity: '数量',
      receivedNumberOfEach: '可收零散数',
      impQty: '导入数量',
      discrepancyQty: '差异数量',
      model: '版本',
      modelID: '版本ID',
      modelName: '版本',
      modelNameA: '版本名称',
      serialNumber: '唯一码',
      number: '件数',
      receivedNumber: '可收件数',
      actualReceivedNumber: '实收件数',
      actualReceivedQuantity: '实收数量',
      inventoryReason: '盘点原因',
      lockedLocation: '货位锁定',
      operator: '操作员',
      approver: '审核员',
      approved: '已审核',
      maker: '制单员',
      receivingman: '收货员',
      shelver: '上架员',
      closer: '关单员',
      remover: '下架员',
      reviewer: '复核员',
      inspector: '验收员',
      dispatcher: '调度员',
      dispatchingTime: '调度时间',
      issuer: '下发员',
      deliver: '配送员',
      submissionAdviceOperator: '申请人',
      submissionAdviceContent: '申请意见',
      approvalAdviceOperator: '审核人',
      approvalAdviceContent: '审核意见',
      reportAdviceOperator: '销毁申请人',
      reportAdviceContent: '销毁申请意见',
      destructionAdviceOperator: '销毁人',
      destructionAdviceContent: '销毁意见',
      shelvesNumber: '上架件数',
      shelvesNumberOfEach: '上架零散数',
      assessment: '验收评定',
      actualLocation: '实际货位',
      upOrderNo: '上级单据编号',
      downSide: '单据下传方',
      receiptCompleted: '收货完成',
      allocateLocation: '计划货位',
      item: '商品',
      itemLotQuery: '商品批号查询',
      itemLot: '商品批号',
      lotDetail: '批号明细',
      putawayType: '上架类型',
      accordingOrder: '按单据上架',
      accordingZone: '按区域上架',
      printProductionDate: '打印生产日期',
      printValidUntil: '打印有效期至',
      returnReason: '退货原因',
      returnOrderNo: '退货单号',
      executed: '已执行',

      appearance: '包装外型',
      shape: '形状',
      roundingMode: '取整方式',
      robotArmNumber: '机械手序列',
      separationOfLabel: '标签分割量',
      label: '标签',
      modelSecond: '小版本',
      modelFirst: '基础版本',
      modelThird: '标签',
      modelFourth: '包装指令单号',

      //addByMaterialQuota
      productInfo: '成品信息',
      category: '类别',
      categoryName: '类别名称',
      categoryNo: '类别编码',
      categoryClassification: '类别分类',
      bom: '物料清单',
      materialInfo: '物料信息',
      index: '序号',
      materialName: '物料名',
      deviation: '偏差',
      deviationRatio: '偏差系数',
      master: '主包装',
      sourceOwnerName: '原货主',
      sourceItemName: '原商品',
      targetOwnerName: '目地货主',
      targetItemName: '目地商品',
      invoiceTime: '开票时间',
      inspectTime: '验收时间',
      removingStartTime: '下架开始时间',
      removingFinishTime: '下架结束时间',
      shelvingStartTime: '上架开始时间',
      shelvingFinishTime: '上架结束时间',
      shelvingTime: '上架时间',
      orderNoA: '业务单号',
      customerNoA: '客户编号',
      customerNameA: '客户名称',
      orderStatusA: '单据状态',
      numberOfOdd: '零散数',
      numberOfPackages: '箱数',
      numberOfItem: '品规数',
      numberOfFcl: '整箱数',
      numberOfLcl: '拼箱数',
      numberOfEach: '零散数',
      numberOfRefrigeration: '冷藏品数',
      numberOfValuable: '贵重品数',
      numberOfImportation: '进口品数',
      numberOfPsychotropic: '精神品数',
      numberOfSpecial: '特管品数',
      numberOfPeptides: '蛋肽品数',
      numberOfGift: '赠品数',
      numberOfOthers: '其它品数',
      numberOfSupervised: '监管码数',
      standardCaseQuantity: '折合件数',
      amount: '金额',
      noOfSGA: '暂存区编号',
      nameOfSGA: '暂存区编号',
      typeOfSGA: '暂存区类型',
      dirOfSGA: '暂存区配送方向',
      orderTypeOfSGA: '暂存区订单类型',
      itemTypeOfSGA: '暂存区商品类型',
      pickMode: '提货方式',
      orderOperator: '业务员',
      beginSGA: '起始暂存区',
      endSGA: '终止暂存区',
      beginDate: '起始日期',
      endDate: '终止日期',
      date: '日期',
      stockOutSGA: '出库暂存区',
      PurchaseReturnSGA: '购进退出暂存区',
      type: '类型',
      limitType: '限定类型',
      caseThreshold: '箱数阈值',
      countingType: '盘点类型',
      queryTerms: '查询条件',
      addContainer: '增加容器',
      print: '打印',
      reviewConfirmed: '复核确认',
      SGA: '暂存区',
      time: '时间',
      reversedItem: '冲红品规',
      workCompletionTime: '作业完成时间',
      worker: '作业人员',
      reviewPrintTime: '复核单打印时间',
      barcode: '条码',
      itemBarcode: '商品条码',
      inversed: '冲红',
      itemSpecification: '商品规格',
      batchNoA: '企业批号',
      approvalNo: '批准文号',
      pickingCompletionTime: '拣货完成时间',
      review: '复核',
      obtainTime: '索取时间',
      pickLocation: '拣货货位',
      picker: '拣货员',
      inventoryTurnoverMode: '库存周转方式',
      stagingCompletion: '集货完成',
      distributionDirection: '配送方向',
      upperNo: '上级编号',
      typeNo: '类型编号',
      typeName: '类型名称',
      physical: '物理',

      pickUpMode: '提货方式',
      lastRoadway: '前置巷道',
      nextRoadway: '后置巷道',
      host: '打印服务端名称',
      ip: '打印服务端IP地址',
      mac: '客户端MAC地址',
      printer: '打印机名称',
      warehouse: '仓库',
      releasable: '放行',
      modelControl: '版本控制',
      codeInitial: '编码首字母',
      codeLength: '编码长度',
      volume: '体积',
      halfVolume: '半箱体积',
      inventoryType: '盘点类型',
      showLocation: '显示货位',
      targetLocation: '目的货位',
      targetStorageRoom: '目的库房',
      actualCountQuantity: '实盘数量',
      actualCountNumber: '实盘件数',
      actualCountAmount: '实盘零散数',
      reason: '原因',
      moveOutLocation: '移出货位',
      moveInLocation: '移入货位',
      moveOutContainer: '移出容器',
      moveInContainer: '移入容器',
      no: '编号',
      beginNo: '起始编号',
      endNo: '终止编号',
      name: '名称',
      englishName: '英文名',
      mnemonicCode: '助记码',
      mnemonicCodeA: '商品助记码',
      customerMnemonicCode: '客户助记码',
      customerMnemonicCodeA: '单位助记码',
      availableStock: '可用库存',
      packagingUnit: '包装单位',
      packageNumber: '包装数',
      packType: '包装类型',
      warehouseId: '仓库ID',
      warehouseNo: '仓库编号',
      warehouseName: '仓库名称',
      //客户和供应商
      logisticsInfo: '物流信息',
      turnoverMode: '周转方式',
      businessman: '业务员',
      numberOfLot: '批号数',
      outboundNumberOfLot: '出库批号数',
      inner: '内部使用',
      downStream: '客户',
      pickupModeName: '提货方式',
      upStream: '供应商',
      dataSource: '数据来源',
      addTime: '添加时间',
      editTime: '更新时间',
      customerCategory: '客户分类',
      code: '地址编号',
      company: '公司',
      contactor: '联系人',
      phone: '联系电话',
      email: '电子邮箱',
      idType: '证件类型',
      idNumber: '证件号',
      country: '国家',
      regions: '营运区',
      province: '省份',
      city: '城市',
      district: '行政区',
      town: '县/镇',
      village: '乡/村',
      street: '街道',
      postalCode: '邮编',
      detailAddress: '详细地址',
      direction: '方向',
      directionNo: '方向编号',
      directionName: '方向名称',
      directionInfo: '方向信息',
      route: '路线',
      routeNo: '路线编号',
      routeName: '路线名称',
      routeInfo: '路线信息',
      contact: '联系人',
      orderOfLoading: '装车顺序',
      defaults: '默认',
      dayOfWeek: '周几',
      supplierNo: '供应商编号',
      supplierName: '供应商名称',
      supplierCategory: '供应商分类',

      //employee
      employeeNo: '职员编号',
      employeeName: '职员名称',
      department: '部门',
      departmentNo: '部门编号',
      departmentName: '部门名称',
      numberOfOrder: '复核任务数',
      numberOfTask: '任务个数',
      numberOfCase: '整包件数',
      signatureType: '签名类型',
      userNo: '用户编号',
      username: '用户名',
      usernameA: '姓名',

      password: '登录口令',
      specialAuthority: '特殊权限',
      queryable: '可查询',
      operable: '可操作',
      roleAuthority: '角色权限',
      itemTypeAuthority: '商品类型权限',
      orderTypeAuthority: '订单类型权限',
      ownerAuthority: '货主权限',
      warehouseAuthority: '仓库权限',
      menuAuthority: '菜单权限',
      methodNo: '方法编号',
      methodName: '方法名称',
      application: '应用类型',
      selectedMenu: '已选菜单',
      selectingMenu: '待选菜单',

      menuId: '菜单ID',
      menuName: '菜单名称',
      menuNo: '菜单编号',
      parentMenu: '上级菜单',
      menuOrdinal: '菜单顺序',
      parameter: '调用参数',
      url: '调用对象',
      icon: '菜单图标',
      reportNo: '报表代码',
      leaf: '末级',
      functional: '功能菜单',
      shortcutKey: '快捷键',
      signable: '需要验证',
      unlockCategory: '特殊权限类别',
      workstation: '工作站',

      //通用
      serial: '序号',
      action: '操作',
      zone: '区域',
      sourceZone: '原区域',
      sourceStorageRoom: '原库房',
      sourceActivated: '可补出',
      targetActivated: '可补入',
      targetZone: '目的区域',

      available: '可用',
      importation: '进口',
      supervised: '监管',
      abnormality: '异型',
      supervisionCodeInitial: '监管码首字母',
      supervisionCodeLength: '监管码长度',
      universalName: '通用名',
      permitHolder: '许可持有人/委托方',
      patentNum: '专利号',
      patentDay: '专利效期',
      storageNotes: '存储注意事项',
      checkContents: '重点核实内容',
      newProduct: '新品',
      coldStorage: '冷藏',
      valuable: '贵重',
      psychotropic: '精神',
      psychotropic2: '二类精神',
      special: '特管',
      specialIngredient: '特殊成分',
      peptides: '蛋肽',
      gift: '赠品',
      fallible: '易发错',
      perishable: '易变质',
      approvalConfirm: '校验批准文号',
      lotControl: '效期控制',
      autoAccepting: '自动验收',
      autoPutaway: '自动上架',
      scattered: '拆零',
      duplex: '双人操作',
      visualized: '视觉复核',
      tagPrice: '吊牌价',
      retailPrice: '零售价',
      wholesalePrice: '批发价',
      settlementPrice: '结算单价',
      flittingCostPrice: '调拨成本价',
      costPrice: '成本价',
      purchasePrice: '采购价',
      price: '单价',
      positionType: '位置类型',
      region: '逻辑区域',
      unitedRegion: '大区',
      storageRoomInfo: '库房信息',
      zoneInfo: '区域信息',
      locationInfo: '货位信息',
      unallocatedQuantity: '未分配数量',
      original: '原行',
      native: '原生',
      //库房
      storageRoomName: '库房名称',
      storageRoomNo: '库房编号',
      storageRoomType: '库房类型',
      storageEnvironment: '存储环境',
      storageClassification: '存储分类',
      storageRequest: '存储条件',
      numberOfBarcode: '补货条码数',
      numberOfPickingOrder: '拣货单数',
      exchangeStorageRoom: '换箱库房',
      caseOnly: '纯整',
      containerType: '容器类型',
      allocable: '设备分货位',
      aggregate: '扎堆',
      checkable: '复核',
      weighable: '称重',
      serialNumberManagement: '序列号管理',
      tag: '标记',
      reservedLocations: '预留空位数',
      columnMonopoly: '独占列',
      // 区域
      zoneName: '区域名称',
      zoneNo: '区域编号',
      zoneType: '区域类型',
      floor: '楼层',
      fullload: '满载量',
      fetchMode: '抓取方式',
      putawayMode: '补货上架方式',
      transmissionType: '传送类型',
      pickupMode: '提货方式',
      pickingMode: '拣选方式',
      autoObtain: '自动索取',
      autoConfirm: '自动确认',
      singleWork: '单人作业',
      // 货位
      locationName: '货位名称',
      locationNo: '货位编号',
      roadway: '巷道',
      row: '排',
      layer: '层',
      column: '列',
      depth: '深度',
      locationType: '货位类型',
      storageType: '存放类型',
      rackType: '货架类型',
      capacity: '容量',
      mechanicalLocking: '设备锁定',
      standardCapacity: '标准容量',
      standardContainerCapacity: '标准容器容量',
      layers: '层数',
      units: '单位数',
      storageState: '存放状态',
      locationStatus: '货位状态',
      saleClassification: '销售分类',
      abcClassification: 'ABC分类',
      approvalValidUntil: '批准文号效期',
      pileupType: '码放类型',
      length: '长',
      width: '宽',
      height: '高',
      occupiedCapacity: '占用容量',
      transferLine: '输送线',
      weight: '重量',
      shortNo: '短编号',
      containerControl: '容器控制',
      automatic: '自动化',
      locking: '锁定',

      plannedQuantity: '计划数量',
      actualQuantity: '实际数量',
      actualNumber: '实际件数',
      actualOddNumber: '实际零散数',
      claimQuantity: '索取数量',
      asnOrderNo: 'ASN单号',
      dosageForm: '商品剂型',
      returnRejectQuantity: '拒退数量',
      rejectedQuantityOfReceipt: '拒收数量',
      rejectedQuantityOfAcceptance: '拒验数量',
      returnOperator: '退货员',
      whetherPrint: '打印',
      plannedOddNumber: '计划零散数',
      plannedNumber: '计划件数',
      checkConfirm: '复核确认',
      stockOutNo: '出库单号',
      shipmentMode: '提货方式',
      carrierName: '承运商',
      expressCode: '运单号',
      allocateMode: '分配方式',
      allocateOrdinal: '分配顺序',
      shipOrder: '发货顺序',
      operationType: ' 操作类型',
      receivable: '可收货',
      shippable: '可发货',
      transferable: '可移库',
      countable: '可盘点',
      wrapping: '裹膜',
      fragile: '易碎',
      hazardous: '危险品',
      liquid: '液体',
      catchWeight: '称量',
      transportable: '可输送',
      autoPalletization: '自动码盘',
      internal: '内部',
      separable: '分单',
      uShape: 'U型',
      entire: '整出',
      chargeup: '记账',
      inspectable: '检验',
      refundable: '退货',
      autoReview: '自动复核',
      shortable: '快速',
      oneStep: '一键出库',
      depositable: '寄存',
      autoAsn: '自动生成ASN',
      autoReceiving: '自动收货',
      autoCompletion: '自动收货完成',
      delegable: '委托',
      exchangeable: '交换',
      autoHandover: '自动交接',
      autoApproval: '自动审核',
      autoDistribution: '自动分销',
      convertible: '改包',
      reversible: '返仓',
      coding: '赋码',
      producible: '生产',
      autoPacking: '自动打包',
      autoRelease: '自动下发',
      distributionType: '分销类型',
      pickupModeOrdinal: '提货方式出库顺序',
      autoStaging: '自动集货',
      autoIssue: '自动下发',
      sourceInventoryState: '原库存状态',
      targetInventoryState: '目标库存状态',
      standardCaseQuantityPerLocation: '每货位标准件数量',
      ordinal: '顺序',
      role: '角色',
      roleNo: '角色编号',
      roleName: '角色名称',
      post: '岗位',
      upperBound: '库存上限',
      lowerBound: '库存下限',

      commandId: '指令ID',
      commandGroup: '指令分组',
      commandStatus: '指令状态',
      theRoadWay: '原巷道',
      newRoadWay: '目的巷道',
      thePlatform: '站台号',
      priority: '优先级',
      operatingType: '作业方式',
      generatedTime: '生成时间',
      exceptionMessage: '异常信息',
      sourceLocation: '原货位',
      timeInterval: '时间间隔(分钟)',
      approvalContentResult: '审核内容及结果',
      checkProject: '检查项目',
      checkStandard: '检查标准',
      checkResult: '检查结果',
      releaseApprovalState: '放行审核状态',
      releaseNo: '放行单号',
      checkNo: '检验单号',
      qualityNo: '质检单号',
      applyTime: '申请时间',
      rejectedReason: '拒收原因',

      invoiceMember: '开票员',
      lossQuantity: '报损数量',

      inventoryStatusChange: '库存状态变化',
      treatmentSuggestion: '处理意见',
      parameterMeaning: '参数含义',
      parameterValue: '参数值',
      parameterNote: '参数备注',
      parameterName: '参数名称',
      parameterType: '参数类型',
      customized: '自定义',
      //dictionary
      dictionary: '字典',
      dictionaryNo: '字典编号',
      dictionaryName: '字典名称',
      dictionaryType: '字典类型',
      dictionaryValue: '字典值',
      dictionaryList: '字典列表',
      dictionaryInfo: '字典信息',
      alignment: '对齐方式',
      displayMode: '显示模式',
      fieldType: '字段类型',
      fieldLength: '字段长度',
      fieldPrecision: '字段精度',
      fieldOrdinal: '字段值',
      fieldContent: '字段内容',
      fieldId: '行号',
      fieldNo: '字段编号',
      fieldName: '字段名称',
      fieldList: '字段列表',
      fieldInfo: '字段信息',
      pickingOrderNo: '拣货单号',
      taskGroup: '任务分组',
      identifier: '标识符',
      printed: '已打印',
      invQuantity: '库存数量',
      id: 'ID',

      warehouseAddress: '仓库地址',
      operate: '操作',
      autoPrint: '自动打印',
      barcode2: '历史条码',
      messageInfo: '此功能适用于上线或搬家, 批量生成库存, 保存后不可撤销, 请谨慎操作！',
      identificationCode: '标识码',

      importDate: '导入时间',
      messageDate: '请选择起止日期',
      state: '状态',
      all: '全部',
      noConfirmOrder: '未确单',
      confirmedOrder: '已确单',
      received: '已入库',
      receipt: '收货单',
      drawer: '制单员',
      auditor: '确单员',
      confirmationTime: '确单时间',
      pending: '待处理',
      delivered: '已完成',
      operationTime: '作业时间',
      lotId: '批号ID',
      lot: '批号',
      returnAcceptQuantity: '退货验收数量',
      purchaseOrder: '采购单',
      color: '颜色',
      colorId: '颜色ID',
      colorName: '颜色',
      size: '尺码',
      sizeId: '尺码ID',
      sizeName: '尺码',
      serialNumberId: '唯一码ID',
      serialNumberNo: '唯一码',
      logicalStore: '逻辑仓',
      logicalStoreNo: '逻辑仓编号',
      logicalStoreName: '逻辑仓名称',
      parentLogicalStore: '上级逻辑仓',
      inboundWorkstation: '补货站台',
      arrivalTime: '到达时间',
      call: '叫车',
      locationBarcode: '库位条码',
      noStock: '无库存',
      inStock: '有库存',
      same: '同商品库位',
      currentLocation: '当前库位',
      storageLocationDiagram: '库位示意图',
      outboundComplete: '已出库',
      seedComplete: '已播种',
      callComplete: '已叫车',
      positionNo: '箱号',
      returnGoods: '退货',
      noReturnGoods: '非退货',
      lessnessQuantity: '库存不足数',
      basket: '篮号',
      seedQuantity: '播种数量',
      callCarWorkStation: '叫车站台',
      stock: '库存数',
      sourceContainer: '原容器',
      targetContainer: '目的容器',
      countingTime: '盘点时间',
      countingOperator: '盘点员',
      balance: '结存',
      grossBalance: '总结存',
      receiptOrderNo: '收货单号',
      shipmentOrderNo: '出库单号',
      allocateQuantity: '分配数量',
      putawayQuantity: '上架数量',
      receivingTime: '收货时间',
      deliveryQuantity: '出库数量',
      deliveryTime: '出库日期',
      errorMessage: '错误消息',
      errorTimes: '错误次数',
      totalLocation: '总货位数',
      freeLocation: '空闲货位数',
      lockingLocation: '锁定货位数',
      locationProgress: '货位利用率',
      saleOrderNo: '销售单号',
      tempControlMode: '温控方式',
      departureTime: '启运时间',
      departureTemp: '启运温度',
      arrivalTemp: '到达温度',
      maximumTemp: '最高温度',
      minimumTemp: '最低温度',
      conveyance: '运输工具',
      shortName: '简称',
      classification: '分类',
      address: '地址',
      mergeOrder: '合单',
      reserveOnly: '只出预留库存',
      wave: '波次',
      taskId: '任务ID',
      shipmentBarcode: '出库条码',
      checkoutContainer: '记账容器',
      checkoutLocation: '记账货位',
      appendageSign: '追加标识',
      pickingStartTime: '拣货开始时间',
      pickingFinishTime: '拣货结束时间',
      exchangePosition: '换箱位',
      exchangeContainer: '换箱容器',
      exchangingPositionAllocatedTime: '换箱位分配时间',
      exchangeTime: '换箱时间',
      exchanger: '换箱员',
      seedingPosition: '分播位',
      seedingContainer: '分播容器',
      seedingPositionAllocatedTime: '分播位分配时间',
      seeder: '分播员',
      seedingStartTime: '分播开始时间',
      seedingFinishTime: '分播结束时间',
      visualReviewedTime: '视觉复核时间',
      seedingMode: '播种方式',
      packingMode: '打包方式',
      packingPosition: '打包位',
      packingContainer: '打包容器',
      packingPositionAllocatedTime: '打包位分配时间',
      packer: '打包员',
      packingStartTime: '打包开始时间',
      packingFinishTime: '打包结束时间',
      bigRegion: '大区',
      stagingRegion: '集货大区',
      stagingPosition: '集货位',
      stagingType: '集货区类型',
      conveyor: '输送线',
      stagingReviewer: '集货复核员',
      reviewStartTime: '集货开始时间',
      reviewFinishTime: '集货结束时间',
      activated: '已激活',
      autoSeeding: '自动分播',
      config: '配置',
      menu: '菜单',
      menuDetail: '菜单详情',
      roleList: '角色列表',
      roleMenu: '角色菜单',
      jsonData: 'JSON数据',
      validInfo: '效期信息',
      value: '值',
      sourcePosition: '起始位置',
      targetPosition: '目标位置',
      backend: '后台',
      flowType: '流程类型',
      employeePost: '职员岗位',
      printNo: '打印编号',
      printName: '打印名称',
      printStatement: '打印语句',
      printTemplate: '打印模板',
      paperLength: '纸张长度',
      paperWidth: '纸张宽度',
      paperSize: '纸张尺寸',
      templatePath: '模板路径',
      returnList: '退货列表',
      receivingList: '收货列表',
      saleReturn: '销退验收',
      receiving: '收货',
      returnType: '退货类型',
      receivingType: '收货类型',
      invoiceQuantity: '开票数量',
      contactMan: '联系人',
      contactPhone: '联系电话',
      enterprise: '企业',
      orderStrategy: '订单策略',
      waveStrategy: '波次策略',
      pickingContainerType: '拣选容器类型',
      additionPickingMode: '追加拣货方式',
      weightDeviation: '称重偏差',
      orderSplitting: '订单拆分',
      taskPrebuilt: '任务预生成',
      orderProperty: '订单属性',
      hotline: '热线',
      completed: '已完成',
      sent: '已发送',
      sendingErp: '推送ERP',
      matrixSortingMode: '矩阵分拣方式',
      alternateType: '备用类型',
      invertible: '返仓',
      supplemental: '补给',
      temporary: '暂存',
      autoSubmit: '自动提交',
      autoRetry: '自动重试',
      autoInversionApproval: '自动冲红审核',
      autoCleanup: '自动清空暂存区',
      goback: '余量回库',
      carrier: '载体',
      position: '位置',
      currentPosition: '当前位置',
      lastPosition: '上次位置',
      traceNo: '跟踪号',
      pickingOrder: '拣货单',
      destination: '目的地',
      workload: '工作量',
      replenishSourceZone: '补出区',
      replenishTargetZone: '补入区',
      replenishTargetStorageRoom: '补入库房',
      replenishSourceStorageRoom: '补出库房',
      obtainTimes: '索取次数',
      handover: '交接',
      vehicleNo: '车牌号',
      vehicleName: '车名',
      vehicleType: '车型',
      vehicleInPlaceStatus: '车辆到位状态',
      ownerEnterprise: '归属企业',
      driver: '司机',
      vehicleDispatched: '已派车',
      status: '状态',
      qualityStandard: '质量标准',
      expirationTime: '过期时间',
      practiceNo: '规范证号',
      approveDate: '批准日期',
      licenseNo: '执照号',
      permissionNo: '许可证号',
      effectiveTime: '生效时间',
      arrivalQuantity: '到货数量',
      returnCustomer: '退货单位',
      supplier: '供应商',
      inspection: '是否验收',
      inboundStorageRoom: '入库库房',
      receiptConclusion: '验收结论',
      returnTotalQuantity: '退货总数',
      receiptTotalQuantity: '收货总数',
      locationLimit: '货位限定',
      unacceptedQuantity: '未验收数',
      unreceivedQuantity: '未收货数',
      rejectedQuantityOfReturn: '退货拒收',
      receivedQuantity: '收货数量',
      inspectedQuantity: '质检数量',
      acceptedQuantity: '验收数量',
      legalAttribute: '法定属性',
      brand: '品牌',
      season: '季节',
      cases: '箱数',
      SmallPackUnit: '小包装单位',
      QuantityOfInnerPack: '中包装数量',
      QuantityOfLargePack: '大包装数量',
      scanned: '已扫描',
      supervisionCode: '监管码',
      deleteSupervisionCode: '删除监管码',
      totalQuantity: '总数量',
      startTime: '开始时间',
      endTime: '结束时间',
      palletNo: '托盘条码',
      returnMethod: '退货方式',
      obtainedQuantity: '已索数量',
      countingOrderNo: '盘点单号',
      sourceLogicalStore: '原逻辑仓',
      transferQuantity: '移库数量',
      data: '数据',
      scheduleType: '消息类型',
      ordersCount: '单据数',
      inverseQuantity: '冲红数量',
      reviewDesk: '复核台',
      turnoverBox: '周转箱',
      storageLocation: '存储位',
      groupage: '拼箱号',
      issueTime: '下发时间',
      stagingArea: '暂存区',
      printTimes: '打印次数',
      unqualifiedQuantity: '不合格数量',
      unqualifiedReason: '不合格原因',
      rejectedQuantity: '拒收数量',
      important: '重点',
      completeMaintenance: '已养护',
      maintenanceQuantity: '养护数量',
      maintenanceMeasure: '养护措施',
      maintenanceAdvice: '养护意见',
      existingInventory: '现有库存',
      sourceInventoryQuantity: '原库存数量',
      changeBoxQuantity: '换箱数量',
      taskType: '任务类型',
      caseOutBound: '整箱出库',
      seedingReplenishmentExchangeBox: '分播/补货换箱',
      tailBoxExchangeBox: '尾箱换箱',
      scanContainer: '扫描容器',
      countingTask: '盘点任务',
      restInventory: '剩余库存',
      collectQuantity: '采集数',
      collectTime: '采集时间',
      multiple: '一箱多品',
      seedingQuantity: '分播数量',
      reviewQuantity: '复核数量',
      error: '错误',
      true: '是',
      false: '否',
      actived: '已激活',
      sourceRoadway: '原巷道',
      targetRoadway: '目的巷道',
      weighed: '已称重',
      supplyQuantity: '供包数量',
      sourceSupplyQuantity: '原供包数量',
      targetSupplyQuantity: '目标供包数量',
      orderCount: '订单数',
      numberOfPlasticBox: '胶箱数',
      numberOfCartonBox: '纸箱数',
      numberOfInsulationBox: '保温箱数',
      loadingOrderNo: '装车单号',
      customerCount: '客户数',
      dock: '码头',
      materialStatistics: '物资统计',
      reviewStatistics: '复核台统计',
      shelfStatistics: '货架统计',
      unDeliveryStatistics: '非配统计',
      coldStatistics: '冷链统计',
      autoReceipt: '自动收货',
      PrintOrNot: '是否打印',
      inspectionType: '质检类型',
      minValue: '最小值',
      maxValue: '最大值',
      sampleValue: '样本量',
      planCycle: '计划周期',
      waveCount: 'ERP波次号',
      appointed: '指定下发',
      pickingCompleted: '拣货完成',
      hasInversion: '存在冲红',
      inverse: '整单冲红',
      stagingCompleted: '集货完成',
      arranged: '已排车',
      outlets: '格口号',
      numberOfLocations: '货位数',
      numberOfContainers: '托盘数',
      numberOfFixedLocations: '固定货位数',
      licenseCheck: '校验三证',
      instruments: '医疗器械',
      patentMedicine: '成药',
      chineseMedicine: '中药',
      group: '部门分组',
      intercept: '拦截',
      interceptionType: '拦截类型',
      parent: '上级',
      computer: '计算器',
      threshold: '阈值',
      arrangeStartTime: '调度开始时间',
      arrangeFinishTime: '调度结束时间',
      issueStartTime: '下发开始时间',
      issueFinishTime: '下发结束时间',
      progress: '进度',
      autoReplenish: '自动补货',
      disqualified: '不合格仓'
    }
  },
  radio: {
    itemInformation: '商品信息',
    showLocation: '显示货位',
    containerInformation: '容器编号'
  },
  tab: {
    itemTable: '商品列表',
    itemInformation: '商品信息',
    locationLimit: '货位限定',
    inventoryLimit: '库存限定',
    detailsInformation: '详细信息',
    customerList: '客户列表',
    supplierList: '供应商列表',
    customerInformation: '客户明细',
    order: '单据',
    orderDetails: '单据详情',
    details: '详情',
    packInfo: '包装信息',
    lotInfo: '批号信息',
    supplierInformation: '供应商明细',
    addressInformation: '配送地址',
    enterpriseList: '企业',
    warehouseList: '仓库列表',
    stagingArea: '暂存区',
    cleanupStagingArea: '暂存区清理',
    stagingType: '暂存区类型',
    employeeTable: '职员列表',
    employeeDetail: '职员明细',
    employeeMenu: '职员菜单',
    employeeInfo: '职员信息',
    arrangeList: '安排列表',
    locked: '已锁定',
    unLocked: '未锁定',
    versionInfo: '版本信息',
    assistInfo: '其它辅助信息',
    itemBaseInfo: '商品基本信息',
    itemDetail: '商品明细',
    obtainedOrder: '已索取订单',
    unObtainOrder: '未索取订单',
    inventoryInfo: '库存信息',
    countingOrder: '盘点单',
    inventoryMerge: '库存合并单',
    orderType: '订单类型',
    pickupMode: '提货方式',
    printList: '打印列表',
    printConfig: '打印配置',
    warehouseData: '仓库资料',
    conveyorConfig: '输送线配置',
    distributionContainerConfig: '分发容器配置',
    automationConfig: '自动作业配置',
    autoTaskUserConfig: '自动任务人员配置',
    storageRoomData: '库房资料',
    shipmentRule: '库房出库规则',
    storageRoomRegion: '库房逻辑区',
    zoneData: '区域资料',
    replenishmentRule: '库房补货规则',
    workstationConfig: '工作站配置',
    pickingModeConfig: '拣选方式配置',
    mondayDelivery: '周一配送',
    tuesdayDelivery: '周二配送',
    wednesdayDelivery: '周三配送',
    thursdayDelivery: '周四配送',
    fridayDelivery: '周五配送',
    saturdayDelivery: '周六配送',
    sundayDelivery: '周日配送',
    asnQuery: 'ASN查询',
    asnCreate: 'ASN制单',
    documentInformation: '证件信息',
    coldChainTemperature: '冷链温度',
    inspectionQuery: '验收查询',
    inspection: '验收',
    shelfByOrder: '按单据上架',
    shelfByArgs: '按条件上架',
    shelfByStereoscopic: '立体库复核',
    receivingList: '收货列表',
    loginTab: '账号--密码--登录',
    countingDetail: '盘点明细',
    waveArrange: '波次安排',
    waveIssue: '波次下发',
    invoiceDetails: '开票明细',
    unStage: '未集货',
    unReview: '未复核',
    taskView: '任务查看',
    internalReview: '内复核',
    orderInfo: '单据信息',
    disqualificationOrder: '不合格单据',
    orderDetail: '单据明细',
    exchangeBox: '换箱',
    exchangeBoxList: '换箱列表',
    seedingDetail: '分播详情',
    seedingList: '分播列表',
    unArrangedOrder: '未排单',
    arrangedOrder: '已排单',
    unIssueLoadingOrder: '未下发装车单',
    issuedLoadingOrder: '已下发装车单',
    autoAcceptanceConfig: '自动验收配置',
    purchaseOrderQuery: '采购查询',
    purchaseOrderCreate: '采购制单',
    saleOrderQuery: '销售查询',
    saleOrderCreate: '销售制单',
    logicalStoreData: '货主逻辑仓',
    inspectionConfig: '质检配置',
    caseTag: '整件标签',
    eachTag: '零货标签',
    replenishTag: '补货标签',
    lightUp: '亮灯',
    lightOff: '灭灯'
  },
  divider: {
    itemBasicInformation: '商品基础信息',
    beforeAdjustment: '调整前',
    adjustmentAfter: '调整后',
    stagingTypeDetail: '暂存区类型详情',
    employeeBaseInformation: '职员基础信息',
    authorityInformation: '权限信息',
    orderMessage: '单据信息',
    detailMessage: '明细信息',
    transferDetails: '移库明细',
    replenishmentDetail: '补货明细',
    orderDetail: '单据明细',
    configurationList: '配置列表',
    configurationDetails: '配置详情',
    bulkEdit: '批量编辑:',
    conversionDetail: '转换明细'

  },
  col: {
    selectModifyProject: '请选择需要修改的项目',
    item: '商品',
    pack: '包装',
    color: '颜色',
    size: '尺码',
    version: '版本',
    lot: '批号',
    batch: '批次',
    serialNumber: '唯一码',
    location: '货位',
    container: '容器',
    quantity: '数量',
    uomOfDimension: 'CM',
    uomOfVolume: 'CM³',
    uomOfWeight: 'KG'
  },
  form: {
    validateInput: '请填写',
    validateSelector: '请选择'
  },
  message: {
    pleaseSelect: '请选择"{0}"',
    pleaseSelectFirst: '请先选择',
    waveAddOrderTip: '请输入波次并勾选单据',
    pleaseInput: '请输入{0}',
    isConfirm: '是否取消编辑',
    isDelete: '是否删除',
    switchLanguage: '切换语言需要重新登录',
    switchLanguageTip: '是否确定切换语言？',
    deleteMenu: '删除菜单后无法恢复',
    deleteMenuTip: '是否确定删除此菜单？',
    canNotBeEmpty: '不能为空',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    saveSuccess: '保存成功',
    saveFailed: '保存失败',
    pleaseInputAccount: '请输入账户名',
    pleaseInputPassword: '请输入密码',
    tip: '提示',
    confirmLogout: '确定要退出登录吗?',
    confirmSwitchWarehouse: '确定要切换仓库吗?',
    confirmDeleteTip: '是否确定删除?',
    menuAddTip: '如新增菜单,注意添加角色权限',
    issueSuccess: '下发成功',
    operationSuccess: '操作成功'
  },
  menu: {
    main: '首页',
    common: '通用功能',
    personalSetting: '个人设置',
    personalCenter: '个人中心',
    menuSearch: '个人中心(菜单搜索)',
    recentlyVisited: '个人中心(最近访问)',
    accountSetting: '账户设置',
    calculator: '计算器',
    switchWarehouse: '切换仓库',
    logout: '退出登录',
    dashboard: '数据仪表盘',
    authorityManage: '权限管理',
    others: '其它',

    index: '主页',
    configuration: '配置',
    configNavigation: '配置导航',
    menuMaintenance: '菜单管理',
    roleAuthority: '角色管理',
    dictionaryMaintenance: '字典管理',
    systemParameterSetting: '参数配置',
    validConfig: '效期配置',
    seedingPositionConfig: '播种位配置',
    packingPositionConfig: '打包位配置',
    layerLocking: '层锁定',
    rowLocking: '行锁定',
    inventoryStateConfig: '库存状态配置',
    inventoryStateSwitchConfig: '库存状态转换配置',
    approveConfig: '审核配置',
    autoPrintConfig: '自动打印配置',
    systemPrintConfig: '系统打印配置',

    baseData: '基础资料',
    employeeData: '用户管理',
    enterpriseMaintain: '企业管理',
    warehouseMaintain: '仓库管理',
    ownerMaintain: '货主管理',
    itemMaintain: '商品管理',
    itemTypeMaintain: '商品类型管理',
    lotMaintain: '批号管理',
    supplierData: '供应商管理',
    customerData: '客户管理',
    stagingTypeMaintain: '暂存区类型维护',
    orderTypeMaintain: '订单类型管理',
    containerTypeMaintain: '容器类型管理',
    containerMaintain: '容器管理',
    conveyorMaintain: '输送线管理',
    storageRoomManage: '库区位管理',
    storageRoomData: '库房管理',
    zoneData: '区域管理',
    locationData: '货位管理',
    addressManagement: '地址管理',
    vehicleMaintain: '车辆管理',
    directionMaintain: '方向配置',

    inbound: '入库作业',
    purchaseOrderMaker: '采购制单',
    asnMake: 'ASN制单',
    receiving: '入库收货',
    inspect: '收货验收',
    shelf: '入库上架',
    receiptClose: '收货关单',
    receiptModify: '收货错误处理',
    receiptPrint: '入库标签补打',

    outbound: '出库作业',
    scheduleErrorHandle: '消息异常处理',
    shipmentDispatch: '出库调度',
    appointDispatch: '指定货位下发',
    oneStepDispatch: '一键出库下发',
    insufficientInventory: '库存不足',
    shortableDispatch: '快速订单下发',
    shortableReview: '快速订单复核',
    shipmentOrderControl: '出库订单管控',
    waveStage: '波次集货',
    containerPacking: '容器打包',
    packingPositionMonitor: '格口监控',
    shipmentPrint: '随货同行单打印',
    viewSeeding: '视觉分播',
    pickingOrderPacking: '拣货单打包',
    outBoundTagPrint: '出库标签补打',
    wavePicking: '波次打单',
    rapidReviewScan: '快递复核扫描',
    automaticPackingScanning: '单品自动打包扫描',
    orderReviewScanning: '后置打单复核扫描',
    weighingScanning: '称重扫描',
    expressHandoverScanning: '快递交接扫描',
    expressForwardingInformation: '快递转发信息',
    afterSalesInboundScan: '售后入仓扫描',
    expressForwardingScan: '快递转发扫描',

    returnManagement: '退货管理',
    purchaseReturnExecution: '购进退出下发',
    purchaseReturnReview: '购进退出复核',
    saleReturn: '销退验收',
    returnDocument: '退货ASN制单',

    warehouseManagement: '库内管理',
    inventoryPlan: '盘点计划',
    temporaryCounting: '临时盘点',
    countingApprove: '盘点审核',
    equipmentMovement: '设备移库',
    normalMovementMake: '普通移库制单',
    normalMovementShelf: '普通移库上架',
    locationAdjust: '货位调整',
    inventoryLockOrUnlock: '库存锁定/解锁',
    activeReplenishment: '主动补货开票',
    deviceMonitor: '设备监控',
    importInventory: '库存导入',
    deliveryManage: '配送管理',
    deliveryLoading: '配送装车',
    deliveryArrange: '配送排车',
    deliveryIssue: '装车下发',
    deliveryConfirm: '装车确认',

    qualityControl: '质量管理',
    disqualificationManagement: '不合格品管理',
    disqualificationApply: '不合格品申请',
    disqualificationConfirm: '不合格品确认',
    disqualificationDestroyApply: '不合格品销毁申请',
    disqualificationDestroyConfirm: '不合格品销毁确认',
    disqualificationQuery: '不合格品记录查询',
    maintenance: '在库养护',
    maintenanceConfig: '养护配置',
    maintenancePlan: '养护计划',
    maintenanceQuery: '养护记录查询',
    inventoryStatusChange: '库存状态变化',

    query: '查询',
    orderTrace: '订单跟踪',
    purchaseOrderQuery: '采购订单查询',
    asnOrderQuery: 'ASN订单查询',
    receiptOrderQuery: '收货订单查询',
    saleOrderQuery: '销售订单查询',
    shipmentOrderQuery: '出库订单查询',
    loadingOrderQuery: '装车单查询',
    detailQuery: '明细查询',
    purchaseDetailQuery: '采购明细查询',
    asnDetailQuery: 'ASN明细查询',
    receiptDetailQuery: '收货明细查询',
    inspectDetailQuery: '验收明细查询',
    receiptRejectDetailQuery: '收货拒收明细查询',
    inspectRejectDetailQuery: '验收拒收明细查询',
    saleDetailQuery: '销售明细查询',
    shipmentDetailQuery: '出库明细查询',
    countingDetailQuery: '盘点明细查询',
    purchaseReturnDetailQuery: '购进退出明细查询',
    saleReturnDetailQuery: '销退验收明细查询',
    commandQuery: '指令查询',
    receiptCommandQuery: '入库指令查询',
    shipmentCommandQuery: '出库指令查询',
    replenishCommandQuery: '补货指令查询',
    transferCommandQuery: '移库指令查询',
    inventoryQuery: '库存查询',
    ledgerQuery: '账页查询',
    balanceQuery: '结存查询',
    balanceStatistics: '结存统计',
    locationUtilisation: '货位使用率',
    statistics: '作业统计'
  },
  title: {
    itemSearch: '商品检索',
    zoneSearch: '区域检索',
    poPickup: 'PO提取',
    asnDetailEdit: 'ASN明细编辑',
    approvalSearch: '批准文号检索',
    licenseSearch: '执照检索',
    permissionSearch: '许可证书检索',
    qualityStandardSearch: '质量标准检索',
    practiceSearch: '规范证书检索',
    SupervisionCodeCollection: '监管码采集',
    ReturnDetailSearch: '退货明细检索',
    ReceiptDetailSearch: '收货明细检索',
    returnPickUp: '退货提取',
    asnPickup: 'ASN提取',
    itemPackMaintain: '包装资料维护',
    receiptDetailEdit: '收货明细修改',
    countingAdd: '盘点新增',
    selectedDetailsWillBeDeleted: '将删除选中明细',
    quantity: '数量',
    targetStorageRoom: '目的库房',
    moveInLocation: '移入货位',
    targetLogicalStore: '目的逻辑仓',
    reason: '原因',
    inventoryLock: '库存锁定',
    replenishmentQuantity: '补货数量',
    containerSearch: '容器信息检索',
    locationSearch: '货位检索',
    lotSearch: '批号检索',
    modelSearch: '批号检索',
    barcodeSearch: '批号检索',
    serialNumberSearch: '批号检索',
    inventorSearch: '库存检索',
    menuSearch: '菜单检索',
    recentlyVisited: '最近访问',
    detailInvert: '明细冲红',
    shipmentBarcodeSearch: '出库条码检索',
    userSearch: '用户检索',
    unqualifiedQuantity: '不合格数量',
    unqualifiedReason: '不合格原因',
    itemInventorSearch: '库存检索',
    activeReplenishmentPickUp: '主动补货提取',
    supplyQuantityMaintain: '供包数量维护',
    inboundScan: '入库扫描',
    inboundComplete: '入库完成',
    seedingPositionBind: '播种位绑定',
    autoTaskUserConfig: '自动任务人员配置',
    storageRoomSearch: '库房检索',
    loadingOrderEdit: '装车单编辑',
    loadingDetailEdit: '装车明细编辑',
    customerSearch: '单位检索',
    coldChainEdit: '冷链信息编辑',
    skuSearch: 'SKU检索',
    conveyorSearch: '输送线检索'
  },
  span: {
    orderNo: '单据编号:',
    owner: '货主:',
    proposer: '申请人:',
    applicationAdvice: '申请意见:',
    maintenanceQuantity: '养护数量',
    maintenanceMeasure: '养护措施',
    maintenanceAdvice: '养护意见'
  },
  option: {
    true: '是',
    false: '否',
    visual: '视觉',
    artificial: '人工',
    hasCollection: '已集货',
    notCollection: '未集货',
    hasReview: '已复核',
    notReview: '未复核',
    outboundCounting: '动销盘点',
    notOutboundCounting: '非动销盘点'
  }
}
